import React from 'react';
import { Button } from '@mui/material';
// import theme from 'theme';
// import { useTheme } from '@mui/material';
const LevelButtonGroup = ({
  updateLevel,
  handleUpdate,
  handleDelete,
  handleCancel,
  handleAdd,
}) => {
  // const theme = useTheme();
  return (
    <div style={{ width: '100%' }}>
      {updateLevel ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            width: '100%',
            marginTop: '1rem',
          }}
        >
          <Button
            variant="contained"
            color="success"
            style={{
              // backgroundColor: 'primary.main',
              // backgroundColor: theme.palette.success.main,
              color: 'white',
              marginTop: 5,
              marginBottom: 5,
              width: 40,
            }}
            onClick={handleUpdate}
          >
            UPDATE
          </Button>
          <Button
            variant="contained"
            color="error"
            style={{
              color: 'white',
              marginTop: 5,
              marginBottom: 5,
              marginLeft: '0.5rem',
              marginRight: '0.5rem',
              width: 40,
            }}
            onClick={handleDelete}
          >
            DELETE
          </Button>
          <Button
            variant="contained"
            color="warning"
            style={{
              color: 'white',
              marginTop: 5,
              marginBottom: 5,
              width: 40,
            }}
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            width: '90%',
            marginTop: '1rem',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{
              color: 'white',
              marginTop: 5,
              marginBottom: 5,
              width: 40,
            }}
            onClick={handleAdd}
          >
            ADD
          </Button>
          <Button
            variant="contained"
            color="warning"
            style={{
              // backgroundColor: '#379683',
              color: 'white',
              marginTop: 5,
              marginBottom: 5,
              width: 40,
            }}
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      )}
    </div>
  );
};

export default LevelButtonGroup;
